function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_290",
  "data-name": "Rectangle 290",
  width: 26,
  height: 26,
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_2868",
  "data-name": "Path 2868",
  d: "M17.354,2.154V.782A.784.784,0,0,0,16.571,0H.783A.784.784,0,0,0,0,.782V2.154ZM8.656,8.71a1.519,1.519,0,0,0-1.511,1.511,1.884,1.884,0,0,0,.112.569,1.511,1.511,0,0,0-.136,2.747H.783A.783.783,0,0,1,0,12.755V3.2H17.354V7.481L17.206,7.4a5.359,5.359,0,0,0-2.576-.662H10.482A1.511,1.511,0,0,0,9.039,8.7Zm4.278,1.048a.524.524,0,0,0,0-1.048H10.482a.463.463,0,1,1,0-.925H14.63a4.3,4.3,0,0,1,2.07.532l.967.533A5.225,5.225,0,0,0,20.18,9.5h1.669a.151.151,0,0,1,.151.15v3.27a.151.151,0,0,1-.151.15H20.1a5.174,5.174,0,0,0-1.85.34l-2.486.945a4.274,4.274,0,0,1-1.525.28H8.656a.463.463,0,1,1,0-.926h4.278a.524.524,0,1,0,0-1.048H7.814a.463.463,0,1,1,0-.926h5.12a.524.524,0,1,0,0-1.047H8.656a.463.463,0,1,1,0-.926Z",
  transform: "translate(3 6.001)",
  fill: "#fff"
});

function SvgIconReturn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_-_return",
    "data-name": "icon - return",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReturn);
export default __webpack_public_path__ + "static/media/icon-return.526261f0.svg";
export { ForwardRef as ReactComponent };